import { Model } from '@descomplica/dex-models';

export interface StudyPlanningBreakpointInfo {
  numberOfMonths: number;
  isPossible: boolean;
  listsPerWeek: number;
  hoursPerWeek: number;
  totalWeeks: number;
  estimatedExpirationDate?: Date;
}

export class StudyPlanningBreakpointModel extends Model {
  numberOfMonths: number;
  isPossible: boolean;
  listsPerWeek: number;
  hoursPerWeek: number;
  totalWeeks: number;
  estimatedExpirationDate?: Date;

  constructor(breakpoint: StudyPlanningBreakpointInfo, getters: any) {
    super(getters);

    this.numberOfMonths = breakpoint.numberOfMonths;
    this.isPossible = breakpoint.isPossible;
    this.listsPerWeek = breakpoint.listsPerWeek;
    this.hoursPerWeek = breakpoint.hoursPerWeek;
    this.totalWeeks = breakpoint.totalWeeks;
    this.estimatedExpirationDate = breakpoint.estimatedExpirationDate;
  }
}
